<script setup lang="ts">
import { AuthMode } from '~/types/interfaces'

const runtimeConfig = useRuntimeConfig()

useSeoMeta({
  title: 'サインイン | Code & Magic',
  description: 'Code & Magicにサインイン',
  ogTitle: 'サインイン | Code & Magic',
  ogDescription:
    '夢中になれたら、学びも遊び。楽しむことから始める、紙とウェブのプログラミング教材。',
  ogImage: `${runtimeConfig.public.serviceDomain}/images/ogPlayMakeShare_wLogo.webp`,
  twitterCard: 'summary_large_image',
})

definePageMeta({
  layout: 'default',
})
</script>

<template>
  <v-container>
    <Auth :mode="AuthMode.SIGNIN" />
  </v-container>
</template>
